const passengers = document.querySelectorAll('.input-passengers-control')

if (passengers.length > 0) {
    passengers.forEach((value, index) => {
        /*Elementos visuales */
        const inputUI = value.querySelector('.packages-passengers')
        const passengersModal = value.querySelector('.people-details')
        const cancelRoomButton = value.querySelector('.cancel-rooms-btn')
        const addRoomButton = value.querySelector('.add-room-btn')
        const deleteButton = value.querySelector('.delete-button')
        const controls = value.querySelector('.controls')
        const groupInfoCard = value.querySelector('.group-trip-info')

        /*Referencias de habitaciones */
        const roomsContainer = value.querySelector('.room-container')
        let roomReference = roomsContainer.querySelectorAll('.room')

        /*Inputs de Submit */
        const inputPassengers = value.querySelector('input.passengers-reservation')
        const teensInputInfo = value.querySelector('input.teens-ages-information')
        const childrenInputInfo = value.querySelector('input.children-ages-information')

        /*Funcion helper para calcular el total de personas para la reserva */
        const getVisibleRooms = () => Array.from(roomsContainer.querySelectorAll('.room.visible'))

        function getTotalPax() {
            const visibleRooms = getVisibleRooms()
            let totalPassengers = 0

            visibleRooms.forEach((room) => {
                room.querySelectorAll('input.fields-quantity').forEach((input) => {
                    const parsed = Number.parseInt(input.value, 10)
                    totalPassengers += Number.isFinite(parsed) ? parsed : 0
                })
            })

            const roomText = visibleRooms.length === 1 ? 'Room' : 'Rooms'

            if (inputUI.dataset.rooms === 'true') {
                inputUI.value = totalPassengers > 0
                    ? `${totalPassengers} Pax, ${visibleRooms.length} ${roomText}`
                    : `0 Pax, ${visibleRooms.length} ${roomText}`
            } else {
                inputUI.value = `${totalPassengers} Pax`
            }
        }

        /*Funcion helper para calcular la data de submit */
        function calculateReservationData() {
            const visibleRooms = getVisibleRooms()
            let respuesta = '|'

            visibleRooms.forEach((room) => {
                const adults = room.querySelector('input[type="number"].adults')
                const children = room.querySelector('input[type="number"].child')
                const infants = room.querySelector('input[type="number"].infants')
                const teens = room.querySelector('input[type="number"].teens')

                respuesta += `${adults?.value ?? 0};${teens?.value ?? 0};${children?.value ?? 0};${infants?.value ?? 0};|`
            })

            if (inputPassengers) {
                inputPassengers.value = respuesta
            }
        }

        /*Aparece la modal al hacer click en el input */
        inputUI.addEventListener('focus', function () {
            passengersModal.classList.remove('d-none')
        })

        /*Desaparece la modal si no haces click en el input o en la modal/tooltip */
        document.addEventListener('click', function (event) {
            const cliceadoFueraDelModal = !passengersModal.contains(event.target)
            const cliceadoFueraDelInput = !inputUI.contains(event.target)


            if (cliceadoFueraDelModal && cliceadoFueraDelInput) {
                passengersModal.classList.add('d-none')

            }
        })

        /*Comportamiento al hacer click en el boton de x en la esquina */
        cancelRoomButton.addEventListener('click', function (e) {
            e.preventDefault()

            passengersModal.classList.add('d-none')

        })


        /*Data rooms */
        if (inputUI.dataset.rooms === 'true') {
            inputUI.value = '2 Pax, 1 Room'
            const title = roomReference[roomReference.length - 1].querySelector('.title')
            title.textContent = 'Room 1'
            let rooms = Number(inputUI.dataset.roomsQuantity) ? Number(inputUI.dataset.roomsQuantity) : 4

            for (let i = 1; i < rooms; i++) {
                const cloneRoom = roomReference[roomReference.length - 1].cloneNode(true)
                const title = cloneRoom.querySelector('.title')
                cloneRoom.classList.add('d-none')
                title.textContent = `Room ${roomReference.length + 1}`
                roomReference[roomReference.length - 1].after(cloneRoom)
                roomReference = roomsContainer.querySelectorAll('.room')
            }



            /*Comportamiento al hacer click en addbutton */
            addRoomButton.addEventListener('click', function (event) {
                const hiddenRooms = Array.from(roomsContainer.querySelectorAll('.room.d-none'))

                if (hiddenRooms.length > 0) {
                    const nextRoom = hiddenRooms[0]
                    nextRoom.classList.remove('d-none')
                    nextRoom.classList.add('visible')
                } else if (groupInfoCard) {
                    groupInfoCard.classList.remove('d-none')
                }

                if (deleteButton) {
                    deleteButton.disabled = getVisibleRooms().length <= 1
                }

                getTotalPax()
                calculateReservationData()
            })

            /*Comportamiento al hacer click en el boton de eliminar*/
            deleteButton.addEventListener('click', function () {
                const visibleRooms = getVisibleRooms()

                if (visibleRooms.length > 1) {
                    const lastRoom = visibleRooms[visibleRooms.length - 1]
                    lastRoom.classList.remove('visible')
                    lastRoom.classList.add('d-none')
                }

                deleteButton.disabled = visibleRooms.length <= 1

                getTotalPax()
                calculateReservationData()
            })



        } else if (controls && groupInfoCard) {
            controls.remove()
            groupInfoCard.remove()

        }
        roomReference[0].classList.add('visible')

        const children = roomsContainer.querySelectorAll('input.room_chd')
        const cardChildrenAge = roomsContainer.querySelectorAll('div.children-ages')
        const teens = roomsContainer.querySelectorAll('input.room_teen')
        const cardteens = roomsContainer.querySelectorAll('div.teens-ages')
        const inputReference = roomsContainer.querySelectorAll('.fields-quantity')
        const adultsReference = roomsContainer.querySelectorAll('.room_adt')
        const infants = roomsContainer.querySelectorAll('.room_inf')

        adultsReference.forEach(value => value.addEventListener('change', function (e) {
            if (e.target.value < 1) {
                e.target.value = 1
            }
            getTotalPax()
        }))

        /**Setup de maximos */

        if (Number(inputUI.dataset.infantsMax)) {
            infants.forEach(value => value.max = Number(inputUI.dataset.infantsMax))
        }

        if (Number(inputUI.dataset.childrenMax)) {
            children.forEach(value => value.max = Number(inputUI.dataset.childrenMax))
        }

        if (Number(inputUI.dataset.adultsMax)) {
            adultsReference.forEach(value => value.max = Number(inputUI.dataset.adultsMax))
        }

        if (Number(inputUI.dataset.teensMax)) {
            teens.forEach(value => value.max = Number(inputUI.dataset.teensMax))
        }

        /*Funcion helper para calcular la data de submit */
        function calculateChildrenAges() {
            const valores = roomsContainer.querySelectorAll('div.children-ages.validos')
            let respuesta = '|'

            valores.forEach(room => {
                const children = room.querySelectorAll('.select-age-chd')

                children.forEach(val => {
                    if (val.value) {
                        respuesta += `${val.value};`
                    }
                })

                respuesta += '|'
            })

            if (childrenInputInfo) {
                childrenInputInfo.value = respuesta
            }
        }

        /*Funcion helper para calcular la data de submit */
        function calculateTeensAges() {
            const valores = roomsContainer.querySelectorAll('div.teens-ages.validos')
            let respuesta = '|'

            valores.forEach(room => {
                const teens = room.querySelectorAll('.select-age-tns')

                teens.forEach(val => {
                    if (val.value) {
                        respuesta += `${val.value};`
                    }
                })

                respuesta += '|'
            })

            if (teensInputInfo) {
                teensInputInfo.value = respuesta
            }
        }

        /*Manejadores de Eventos */
        children.forEach((value, index) => {
            value.addEventListener('change', function () {
                if (value.value > 0) {
                    cardChildrenAge[index].classList.remove('d-none')
                    cardChildrenAge[index].classList.add('validos')
                    let childrenSelect = cardChildrenAge[index].querySelectorAll('.children-ages-input')

                    while (childrenSelect.length !== Number(value.value)) {

                        if (childrenSelect.length < value.value) {
                            const newInput = childrenSelect[childrenSelect.length - 1].cloneNode(true)
                            const select = newInput.querySelector('.select-age-chd')

                            childrenSelect[childrenSelect.length - 1].after(newInput)

                            /*Aplicar evento de change a nuevo select creado */
                            jQuery(select).niceSelect()
                            jQuery(select)
                                .off('change.inputPassengers')
                                .on('change.inputPassengers', calculateChildrenAges)
                        } else if (childrenSelect.length > value.value) {
                            const itemToRemove = childrenSelect[childrenSelect.length - 1]
                            const selectToRemove = itemToRemove.querySelector('.select-age-chd')
                            jQuery(selectToRemove).off('change')
                            jQuery(selectToRemove).niceSelect('destroy')
                            itemToRemove.remove()
                        }
                        childrenSelect = cardChildrenAge[index].querySelectorAll('.children-ages-input')
                    }


                } else {
                    cardChildrenAge[index].classList.add('d-none')
                    cardChildrenAge[index].classList.remove('validos')
                }
                calculateChildrenAges()
            })
        })
        teens.forEach((value, index) => {
            value.addEventListener('change', function () {
                if (value.value > 0) {
                    cardteens[index].classList.remove('d-none')
                    cardteens[index].classList.add('validos')
                    let teensSelect = cardteens[index].querySelectorAll('.teens-ages-input')

                    while (teensSelect.length !== Number(value.value)) {
                        if (teensSelect.length < value.value) {
                            const newInput = teensSelect[teensSelect.length - 1].cloneNode(true)
                            const select = newInput.querySelector('.select-age-tns')

                            teensSelect[teensSelect.length - 1].after(newInput)

                            /*Aplicar evento de change a nuevo select creado */
                            jQuery(select).niceSelect()
                            jQuery(select)
                                .off('change.inputPassengers')
                                .on('change.inputPassengers', calculateTeensAges)
                        } else if (teensSelect.length > value.value) {
                            const itemToRemove = teensSelect[teensSelect.length - 1]
                            const selectToRemove = itemToRemove.querySelector('.select-age-tns')
                            jQuery(selectToRemove).off('change')
                            jQuery(selectToRemove).niceSelect('destroy')
                            itemToRemove.remove()
                        }
                        teensSelect = cardteens[index].querySelectorAll('.teens-ages-input')
                    }


                } else {
                    cardteens[index].classList.add('d-none')
                    cardteens[index].classList.remove('validos')
                }
                calculateTeensAges()
            })
        })

        inputReference.forEach(value => {
            value.addEventListener('change', () => {
                getTotalPax()
                calculateReservationData()
            })
        })

        const ageRoot = roomsContainer

        jQuery(ageRoot)
            .off('change.inputPassengers', '.select-age-chd')
            .on('change.inputPassengers', '.select-age-chd', function () {
                calculateChildrenAges()
            })

        jQuery(ageRoot)
            .off('change.inputPassengers', '.select-age-tns')
            .on('change.inputPassengers', '.select-age-tns', function () {
                calculateTeensAges()
            })

    })
}